import { createContext, useContext, useState, ReactNode, useMemo } from "react";

interface UserContextType {
  sessionInfo: string | null;
  setSessionInfo: (user: string | null) => void;
}

const sessionEditContext = createContext<UserContextType | undefined>(
  undefined
);

export const useSessionEditContext = () => {
  const context = useContext(sessionEditContext);
  if (!context) {
    throw new Error("useSessionEditContext must be used within a UserProvider");
  }
  return context;
};

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [sessionInfo, setSessionInfo] = useState<string | null>(null);
  const contextValue = useMemo(() => ({ sessionInfo, setSessionInfo }), [sessionInfo]);

  return (
    <sessionEditContext.Provider value={contextValue}>
      {children}
    </sessionEditContext.Provider>
  );
};
